import React from "react";
import { Link, useHistory } from "react-router-dom";
// reactstrap components
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip,
} from "reactstrap";

import { useMediaQuery } from "react-responsive";

function EmptyNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);

  const [isLeopardMenuOpen, leopardMenuOpen] = React.useState(false);
  const [isAboutLeopardMenuOpen, aboutLeopardMenuOpen] = React.useState(false);

  const history = useHistory();
  const isMobileMenuEnabled = useMediaQuery({
    query: "(max-width:  991px)",
  });

  React.useEffect(() => {
    if (isMobileMenuEnabled) {
      leopardMenuOpen(true);
    }

    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 100 ||
        document.body.scrollTop > 100
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 100 ||
        document.body.scrollTop < 100
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });

  function toggleLeopardMenuOpen() {
    leopardMenuOpen(true);
    aboutLeopardMenuOpen(false);
  }

  function toggleAboutLeopardMenuOpen() {
    leopardMenuOpen(false);
    aboutLeopardMenuOpen(true);
  }

  function navigateToYalaLeopardHome() {
    leopardMenuOpen(false);
    history.push("/our-identification-convention");
  }

  function closeAllExpandedMenus() {
    if (!isMobileMenuEnabled) {
      leopardMenuOpen(false);
      aboutLeopardMenuOpen(false);
    }
  }

  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top " + navbarColor} expand="lg" color="info">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand href="/" id="navbar-brand">
              <img
                alt="..."
                className="landing-header-logo"
                src={require("assets/img/landing-page/Leopard Diary Logo 50x50.png")}
              ></img>
              Yala Leopard Diary
            </NavbarBrand>
            <UncontrolledTooltip target="#navbar-brand">
              Leopard Identification and more, for Better Conservation
            </UncontrolledTooltip>
            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar>
              <NavItem onMouseOver={() => closeAllExpandedMenus()}>
                <NavLink
                  href="https://www.facebook.com/groups/129638654392324"
                  target="_blank"
                  id="facebook-tooltip"
                >
                  <i className="fab fa-facebook"></i>
                  <p className="d-lg-none d-xl-none">Facebook</p>
                </NavLink>
                <UncontrolledTooltip target="#facebook-tooltip">
                  Follow us on Facebook
                </UncontrolledTooltip>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default EmptyNavbar;
